<template>
  <div class="bigBox">
   <!--标题-->
    <div class="detailsTitle">
      <h4>计划完成情况</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
    </div>
    <div v-loading='contentLoading'>
    <div class="addressBox">
      <h5 class="title">
        <span>
          <i class="fa fa-tag iconFont" aria-hidden="true"></i>整体计划
        </span>
      </h5>
    </div>
      <div class="status_plan clearfix">
        <table class="status_cnt pull-left table">
          <tbody>
          <tr>
            <td>交货日期</td>
            <td >{{purchasePlan.validDate | timeFunction}}</td>
            <td>采购订单号</td>
            <td >{{purchasePlan.purorderNo}}</td>
            <td>采购日计划号</td>
            <td>{{purchasePlan.purplanNo}}</td>
          </tr>
          <tr>
            <td>收货单位</td>
            <td>{{purchasePlan.toOrg}}</td>
            <td>收货仓库</td>
            <td>{{purchasePlan.warehouseNameShow}}</td>
            <td>收料库位</td>
            <td>{{purchasePlan.areaName}}</td>
          </tr>
          <tr>
            <td>物料名称</td>
            <td>{{purchasePlan.goodsName}}</td>
            <td>物料编码</td>
            <td>{{purchasePlan.goodsNo}}</td>
            <td>采购吨数</td>
            <td>{{purchasePlan.purplanWeight}}</td>
          </tr>
          <tr>
            <td>供应商</td>
            <td>{{purchasePlan.fromOrg}}</td>
            <td>港口</td>
            <td>{{purchasePlan.wharfName}}</td>
            <td>货代</td>
            <td>{{purchasePlan.forwarderName}}</td>
          </tr>
          <tr>
            <td>船名</td>
            <td>{{purchasePlan.shipName}}</td>
            <td>创建人</td>
            <td>{{purchasePlan.createUser}}</td>
            <td>创建时间</td>
            <td>{{purchasePlan.createTime | dateFormat}}</td>
          </tr>
          <tr>
            <td>修改人</td>
            <td>{{purchasePlan.updateUser}}</td>
            <td>修改时间</td>
            <td>{{purchasePlan.updateTime | dateFormat}}</td>
            <td>疏港计划号</td>
            <td>{{purchasePlan.planNo}}</td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="5" style="text-align: left;">{{purchasePlan.remark}}</td>
          </tr>
          </tbody>
        </table>
        <div class="pull-right plan_show">
          <div class="div_block">
            <span class="span_cell">计划吨数:</span><span class="black">{{purchasePlan.purplanWeight}}</span>
          </div>
          <div class="div_block">
            <span class="span_cell">已完成:</span><span class="green">{{completeCount}}</span>
          </div>
          <div class="div_block">
            <span class="span_cell">剩余:</span><span class="red">{{(purchasePlan.purplanWeight-this.completeCount).toFixed(3)}}</span>
          </div>
          <div class="div_block">
            <span class="span_cell">完成进度:</span><span class="blue">{{accomplishedPercent}}</span>
          </div>
        </div>
      </div>
      <div class="bottom">
      <div class="addressBox">
        <h5 class="title">
          <span>
            <i class="fa fa-tag iconFont" aria-hidden="true"></i>分配情况
          </span>
        </h5>
      </div>
    </div>
    <!--  表格 -->
    <div class="table" >
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column prop="distributionNo"   label="小计划号" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName" label="操作" width="120" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="handleClick(scope.row)" type="success" size="small" btnCode='001P001B00A' v-if="btnFlg[0]">运单情况</el-button>
          </div></template>
        </el-table-column>
        <el-table-column property="fleetName" label="车队" width="230" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="vehicleTypesName" label="车型" align="center" width="140" :formatter="formatterRowEmpty" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="warehouseName"    label="收货仓库1"  width="150" align="center"></el-table-column>
        <el-table-column prop="carnumLimit" label="车数1" align="center" width="100"></el-table-column>
        <el-table-column prop="locationName"    label="库位1" align="center" width="100" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="wharfxName"  label="码头" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="areaName" label="场区"  align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="stackPosition"    label="垛位"  width="100" align="center" :formatter="formatterRowEmpty" ></el-table-column>
        <el-table-column prop="allocationPercent" label="分配比例（%）" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="distWeight"    label="分配吨数" align="center" width="140" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.distWeight == undefined || scope.row.distWeight == null || scope.row.distWeight == ''">-</span>
            <span v-else>{{scope.row.distWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="ssuttleWeight"  label="出港净重（吨）" align="center" width="140" >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.ssuttleWeight == undefined || scope.row.ssuttleWeight == null || scope.row.ssuttleWeight == ''">-</span>
            <span v-else>{{scope.row.ssuttleWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="surplusOutWeight" label="出港剩余吨数"  align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="percentOut" label="出港完成率"  align="center" width="120" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="esuttleWeight"    label="进厂净重（吨）"  width="120" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="surplusIn" label="进厂剩余吨数" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="percentIn"    label="进厂完成率" align="center" width="140" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="createTime"  label="分配时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    </div>
    <!-- 详细运单 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="waybillMark"
    @close="closeEvent"
    width="85%"
    center>
    <div v-loading='waybillLoading'>
      <span>
        <span>
          <div class="addinpBox">
            <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <span>超限标记：</span>
            <el-select v-model="waybillFrom.overrunFlag" placeholder="请选择" size="mini" style="width:150px;">
              <el-option
                v-for="(item,index) in overrunFlagOptions"
                :key="index"
                :label="item.name"
                :value="item.val">
              </el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>运单状态：</span>
            <el-select v-model="waybillFrom.wayBillStatus" placeholder="请选择" size="mini" style="width:150px;">
              <el-option
                v-for="(item,index) in wayBillStatusOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>收货仓库：</span>
            <el-select v-model="waybillFrom.warehouseName" placeholder="请选择" size="mini" style="width:150px;">
              <el-option
                v-for="(item,index) in warehouseOptions"
                :key="index"
                :label="item.plantName"
                :value="item.plantName">
              </el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>车牌号：</span>
            <el-input  placeholder="" maxlength="100" v-model="waybillFrom.vehicleNo" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br>
            <br>
            <span>采购订单号：</span>
            <el-input  placeholder="" maxlength="100" v-model="waybillFrom.purorderNo" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>采购日计划号：</span>
            <el-input  placeholder="" maxlength="100" v-model="waybillFrom.purplanNo" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>物料名称：</span>
            <el-input  placeholder="" maxlength="100" v-model="waybillFrom.goodsName" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>船名：</span>
            <el-input  placeholder="" maxlength="100" v-model="waybillFrom.shipName" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br>
            <br>
            <el-button type="primary" size="mini" @click="waybillSearchClick">查询</el-button>
            <el-button type="primary" size="mini" @click="resetBtn()">重置</el-button>
            <el-table
              :data="waybillTableList"
              ref="waybillTableList"
              border
              bordersize="mini"
              style="width:100%;margin:10px 0 10px 0"
              center
              :header-cell-style="{background:'#F5F5F5',color:'black'}"
              :header-row-style="{height:'35px'}"
              :row-style="{height:'25px'}"
              highlight-current-row>
              <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="overrunFlag"    label="超限标记" align="center" width="120">
                <template slot-scope="scope"><div>
                  <span v-if="scope.row.overrunFlag == '0'">无</span>
                  <span v-if="scope.row.overrunFlag == '1'">超</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="waybillNo" label="运单编号" align="center" width="220" ></el-table-column>
              <el-table-column prop="wStatusName" label="运单状态" align="center" width="120"></el-table-column>
              <el-table-column prop="goodsName" label="物料名称" align="center" width="180"></el-table-column>
              <el-table-column prop="shipName" label="船名" align="center" width="120"></el-table-column>
              <el-table-column prop="warehouseName" label="收货仓库" align="center" width="160"></el-table-column>
              <el-table-column prop="locationName"  label="收货库位" align="center" :formatter="formatterRowEmpty" width="120"></el-table-column>
              <el-table-column prop="vehicleNo" label="车牌号" align="center" width="120"></el-table-column>
              <el-table-column prop="fleetName" label="车队" align="center"  width="180"></el-table-column>
              <el-table-column prop="planNo" label="疏港计划号（单号）" align="center" width="160"></el-table-column>
              <el-table-column prop="purorderNo" label="采购订单号"  align="center" width="120"></el-table-column>
              <el-table-column prop="purplanNo"  label="采购日计划号" align="center" width="220"></el-table-column>
              <el-table-column prop="driverName" label="司机" align="center" width="120" ></el-table-column>
              <el-table-column prop="driverMobile" label="电话" align="center" width="140"></el-table-column>
              <el-table-column prop="wharfName" label="港口" align="center" width="140"></el-table-column>
              <el-table-column prop="wharfxName" label="码头"  align="center" width="120"></el-table-column>
              <el-table-column prop="areaName" label="码头场区" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="stackPosition" label="码头垛位" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="sfirstTare" label="港口一检皮重" align="center" width="150" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="sgrossWeight" label="港口一检毛重"  align="center" width="150" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="ssuttle" label="港口出货净重" align="center" width="150">
                <template slot-scope="scope"><div>
                  <span v-if="scope.row.ssuttle == undefined || scope.row.ssuttle == null || scope.row.ssuttle == ''">-</span>
                  <span v-else>{{scope.row.ssuttle.toFixed(3)}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="efirstTare" label="进厂一检毛重"  align="center" width="150" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="esuttle" label="进厂货物净重" align="center" width="150" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="grossErrorRate" label="毛重误差率（‰）" align="center" width="150" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="netErrorRate" label="净重误差率（‰）" align="center" width="150" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="wharfSendTime" label="港口派车时间"  align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="sbTime" label="司机上报时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="wharfSendUser" label="派车人" align="center" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="wharfOutTime" label="出港过磅时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="plantInTime" label="进厂过磅时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="plantOutTime" label="出厂过磅时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="finishTime" label="司机完成时间" align="center"  width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="wharfCancelTime" label="撤销时间" align="center"  width="180" :formatter="formatterRowEmpty"></el-table-column>

            </el-table>
                <!-- 分页 10,25,50,100-->
                <!-- <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="heTongFrom.pageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="heTongFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="heTongFrom.total">
                  </el-pagination>
                </div>-->
          </div>
        </span>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="waybillMark = false" size='mini'>关闭</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  planCompletionInfo,
  getPlantList, // 获取收货仓库信息
  wayBillStatusList, // 获取运单状态列表
  getWaybillList
} from '@/api/zhb-sgHarbour.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  filters: {
    rounding (value) {
      return value.toFixed(3)
    }
  },
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '001P001B00A'
      ],
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      title: '',
      h: '200px',
      tableList: [],
      waybillTableList: [],
      waybillMark: false,
      waybillFrom: {
        vehicleNo: '', // 车牌号
        purorderNo: '', // 采购订单号
        purplanNo: '', // 采购日计划号
        goodsName: '', // 物料名称
        shipName: '', // 船名
        warehouse: '', // 收货仓库
        warehouseName: '全部',
        wayBillStatus: '', // 运单状态
        overrunFlag: '', // 超限标记
        pageNo: 1,
        pageSize: 1000,
        distributionId: '' // 分配计划号
      },
      purchasePlan: {},
      result: {},
      purchase: {},
      completeCount: {},
      accomplishedPercent: '',
      overrunFlagOptions: [
        {
          name: '全部',
          val: ''
        },
        {
          name: '未超出',
          val: 0
        },
        {
          name: '已超出',
          val: 1
        }
      ],
      wayBillStatusOptions: [
        {
          'showName': '全部',
          'itemNo': ''
        }
      ],
      warehouseOptions: [
        {
          'plantId': '',
          'plantName': '全部'
        }
      ],
      contentLoading: false,
      waybillLoading: false
    }
  },
  filters: {
    timeFunction: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }

      return year + '-' + month + '-' + date
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/sgPlanManagement/planRelease')
    // this.purchase = this.$route.params.purchasePlan
    this.purchase = JSON.parse(localStorage.getItem('purchasePlan'))
    // console.log(this.purchase)
    this.contentLoading = true
    this.planCompletion()
    this.optionListInit()
  },
  methods: {
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    handleClick (row) {
      this.title = '详细运单'
      this.waybillMark = true
      this.waybillFrom.distributionId = row.distributionId
      this.waybillFrom.purplanId = row.purplanId
      console.log(this.waybillFrom)
      this.showWayBillList()
    },
    showWayBillList () {
      this.waybillLoading = true
      getWaybillList(this.waybillFrom).then(res => {
        this.waybillLoading = false
        this.waybillTableList = res.list
      }).catch(err => {
        this.waybillLoading = false
        this.$message.error(err.message)
      })
    },
    waybillSearchClick () {
      this.showWayBillList()
    },
    // 返回
    backClick () {
      this.$router.go(-1)
      // this.$router.push('/sgPlanManagement/planRelease')
    },
    planCompletion () {
      planCompletionInfo(this.purchase).then(res => {
        this.contentLoading = false
        this.purchasePlan = res.plan
        this.completeCount = Number(res.accomplished).toFixed(3)
        this.tableList = res.distributionList
        this.accomplishedPercent = res.accomplishedPercent
      }).catch(err => {
        this.contentLoading = false
        this.$message.error(err.message)
      })
    },
    optionListInit () {
      if (this.warehouseOptions.length < 2) {
        getPlantList().then(res => {
          this.warehouseOptions = res
          this.warehouseOptions.unshift({ 'plantId': '', 'plantName': '全部' })
          // for (let index = 0; index < res.length; index++) {
          //   const element = res[index]
          //   this.warehouseOptions.push(element)
          // }
        })
      }
      console.log(this.wayBillStatusOptions.length)
      if (this.wayBillStatusOptions.length < 2) {
        wayBillStatusList().then(res => {
          for (let index = 0; index < res.length; index++) {
            const element = res[index]
            this.wayBillStatusOptions.push(element)
          }
        })
      }
    },
    closeEvent () {
      this.waybillMark = false
      this.resetOption()
    },
    resetBtn () {
      this.resetOption(1)
      this.showWayBillList()
    },
    resetOption (param) {
      if (param == null) {
        this.waybillFrom.distributionId = ''
        this.purplanId = ''
      }
      this.waybillFrom.purplanNo = ''
      this.waybillFrom.purorderNo = ''
      this.waybillFrom.vehicleNo = ''
      this.waybillFrom.goodsName = ''
      this.waybillFrom.shipName = ''
      this.waybillFrom.warehouse = ''
      this.waybillFrom.warehouseName = '全部'
      this.waybillFrom.wayBillStatus = ''
      this.waybillFrom.overrunFlag = ''
    }
  }
}
</script>
<style scoped lang='less'>
.bigBox{
  overflow-x: hidden;
}
.status_plan{
  margin-top: -10px;
  margin-left: 10px;
  width: 100%;
  // margin-top: 10px;
  height: 266px;
  overflow: hidden;
}
.status_plan .status_cnt {
    margin-bottom: 16px;
}
.status_cnt {
    width: 76%;
    // margin-top: 10px;
    height: 266px;
}
.pull-left {
    float: left!important;
}
table {
    font-size: 14px;
    border-spacing: 0;
    border-collapse: collapse;
    background-color: transparent;
}
.status_plan table tr td:nth-child(odd) {
    background: #2980B9;
    color: #fff;
    width: 11%;
}
.status_plan table tr td + td {
    border-left: 2px solid #fff;
}
.status_plan table tr td {
    padding: 2px;
    cursor: default;
    border-bottom: 1px solid #fff;
}
.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    // padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
}
.table tr th, .table tr td {
    text-align: center;
    vertical-align: middle!important;
    word-wrap: break-word;
}
.table td, .table th {
    vertical-align: middle;
}
td {
    display: table-cell;
    // vertical-align: inherit;
}
.status_plan table tr td:nth-child(even) {
    word-break: break-word;
    background: rgba(158, 158, 158, 0.39);
    width: 21%;
}
.plan_show {
    box-sizing: border-box;
    width: 22%;
    background: #eef3fa;
    text-align: left;
    font-size: 16px;
    padding: 20px 10px;
    height: 105%;
    // height: 275px;
}
.pull-right {
    float: right!important;
    // margin-right: 15px;
}
.plan_show .div_block {
    line-height: 50px;
}
.plan_show .span_cell {
    min-width: 75px;
    display: inline-block;
    text-align: right;
    // margin-right: 10px;
}
.plan_show .div_block span:nth-of-type(2) {
    float: right;
    margin-right: 10px;
}
.green {
  color: green;
}
.blue {
  color: blue;
}
.red {
  color: red;
}
.black {
  color: #000;
}
.black, .blue, .red, .green {
  font-weight: bold;
  font-size: 18px;
}
.bottom{
  margin-top: 15px;
}
</style>
